import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FileService {
  constructor() {}

  acceptCheck(fileType: string, accept: string = 'text/html') {
    if (!accept) return true;

    const typeRegex = new RegExp(
      accept.replace(/\*/g, '.*').replace(/\,/g, '|'),
    );
    return typeRegex.test(fileType);
  }

  static getBase64ImageSize(base64String: string) {
    // delete Base64 keyword
    const base64Data = base64String.split(',')[1] || base64String;

    // calculate padding
    const padding = (base64Data.match(/=/g) || []).length;

    // calculate size in bytes
    const sizeInBytes = (base64Data.length * 3) / 4 - padding;

    // convert to KB or MB
    const sizeInKB = sizeInBytes / 1024;
    const sizeInMB = sizeInKB / 1024;

    return {
      sizeInBytes,
      sizeInKB: sizeInKB.toFixed(2),
      sizeInMB: sizeInMB.toFixed(2),
    };
  }

  static checkIfImageIsValid(base64Image: string) {
    // استخدام المثال
    const size = FileService.getBase64ImageSize(base64Image);

    //   console.log(`Size in Bytes: ${size.sizeInBytes} bytes`);
    //   console.log(`Size in KB: ${size.sizeInKB} KB`);
    //   console.log(`Size in MB: ${size.sizeInMB} MB`);

    return +size.sizeInKB <= 1000;
  }
}
